@for (tag of $tags(); track tag.id) {
    <div class="cm-card-tag" [style.background]="tag.color">{{ tag.name }}</div>
}
